module.exports = __webpack_public_path__ + "img/home.08d9d9b0.png";